module.exports = __webpack_public_path__ + "img/profile-picture-shantanu-min.0dae97ad.png";